import React, { useEffect, useRef } from 'react'

import styles from './AriaModal.module.css'
import useDialogTabTrap from 'frontend/utils/hooks/useDialogTabTrap'

interface Props {
  isModalOpen: boolean
  onModalClose: () => void
  children: React.ReactNode
}

const AriaModal = ({ isModalOpen, onModalClose, children }: Props) => {
  const modalRef = useRef<HTMLDivElement | null>(null)

  useDialogTabTrap(isModalOpen, modalRef, onModalClose)

  useEffect(() => {
    const freezeScrollForBackground = () =>
      document.documentElement.classList.add(`${styles.noBackgroundScroll}`)
    const removeFreezeForBackground = () =>
      document.documentElement.classList.remove(`${styles.noBackgroundScroll}`)

    if (isModalOpen) {
      freezeScrollForBackground()
    } else {
      removeFreezeForBackground()
    }
    return () => {
      removeFreezeForBackground()
    }
  }, [isModalOpen])

  return (
    isModalOpen && (
      <div ref={modalRef} role="dialog" aria-modal="true">
        {children}
      </div>
    )
  )
}

export default AriaModal
